<template>
    <section class="subscribeInfo">
		<Nav title="订阅信息" />
        <section class="card_list">
            <div class="card">
                <div class="item">
                    <div class="label"><p>机构名称</p></div>
                    <div class="info"><p>{{org.orgName}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>订阅状态</p></div>
                    <div class="info"><p>{{org.subscriptionStatus | f_subscriptionStatus}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>订阅版本</p></div>
                    <div class="info"><p>{{org.subscriptionVersion | f_subscriptionVersion}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>订阅开始时间</p></div>
                    <div class="info"><p>{{org.subscriptionStartTime}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>订阅结束时间</p></div>
                    <div class="info"><p>{{org.subscriptionEndTime}}</p></div>
                </div>
            </div>
            <div class="card" v-if="org.subscriptionStatus==1">
                <div class="item">
                    <div class="label"><p>团队总配额</p></div>
                    <div class="info"><p>{{org.teamTotalQuota}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>团队剩余配额</p></div>
                    <div class="info"><p>{{org.teamRemainingQuota}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>团队管理员总配额</p></div>
                    <div class="info"><p>{{org.teamAdminTotalQuota}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>团队管理员剩余配额</p></div>
                    <div class="info"><p>{{org.teamAdminRemainingQuota}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>业务员总配额</p></div>
                    <div class="info"><p>{{org.salespersonTotalQuota}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>业务员剩余配额</p></div>
                    <div class="info"><p>{{org.salespersonRemainingQuota}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>在投计划数配额</p></div>
                    <div class="info"><p>{{org.investmentPlanQuota}}</p></div>
                </div>
                <div class="item">
                    <div class="label"><p>私有客户数配额</p></div>
                    <div class="info"><p>{{org.privateCustomerQuota}}</p></div>
                </div>
            </div>
        </section>
        <section>
            <div class="button_area">
                <van-button round block type="primary" to="/setting" native-type="submit" v-if="!canReSubscribe">返回</van-button>
                <van-button round block type="primary" to="/subscribe/product" native-type="submit" v-else>立即续订</van-button>
            </div>
        </section>
	</section>
</template>

<script>
import Nav from "components/Nav"

import settingServer from "api/setting";

export default {
    name: "subscribeInfo",
	components: {
		Nav,
	},
    data() {
        return {
            org: {},
            canReSubscribe: false,
		};
    },
    created() {
        this.getInfo();
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},	
    methods: {
        getInfo() {
            settingServer.getOrgInfo().then((res) => {
                this.org = res.data
                this.DiffDate()
            })
        },

        DiffDate() {
            // 结束时间
            let endDateStr = this.org.subscriptionEndTime;
            let endDate = new Date(endDateStr);

            // 获取当前时间
            let nowDate = new Date();

            // 计算两者的时间差，结果是毫秒数
            let timeDiff = endDate.getTime() - nowDate.getTime();

            // 将毫秒数转换成天数
            let dayDiff = timeDiff / 1000 / 60 / 60 / 24;
            console.log(`当前时间距结束时间为${dayDiff}`);

            // 检查天数是否小于30
            if (dayDiff < 30) {
                console.log("当前时间距结束时间小于30天");
                this.canReSubscribe = true;
            } else {
                console.log("当前时间距结束时间大于或等于30天");
                this.canReSubscribe = false;
            }
        },
    },
};
</script>

<style lang="scss">
	.subscribeInfo {
		padding-top: 46px;
		padding-bottom: 100px;

        .card {
            margin-bottom: 22px;
            background-color: #FDFDFD;
            border-radius: 24px;

            .item {
                margin-left: 30px;
                padding: 20px 30px 20px 0;
                border-bottom: 1px solid #E9F0F8;
                display: flex;
                justify-content: space-between;

                .label p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #4D5B80;
                }

                .info p {
                    font-size: 16px;
                    line-height: 20px;
                    font-weight: 400;
                    color: #000;
                }
            }

            .item:last-child {
                border-bottom: 0;
            }
        }

        .button_area {
            position: fixed;
            bottom: 30px;
            width: 100%;
            padding: 0 28px;
        }
	}
</style>


// WEBPACK FOOTER //
// src/views/subscribe/Info.vue